import React, { ReactElement } from 'react';
import { InlineMath } from 'react-katex';
import 'katex/dist/katex.min.css';

// split will make those convertions:
// rep = /(<\/?latex>|<\/?sub>|<\/?sup>)/;
// [
//   "abc<latex>def</latex>ghi<sub>jk</sub>lmn",
//   "<latex>def</latex>ghi<sub>jk</sub>lmn",
//   "<latex>def</latex>ghi<sub>jk</sub><sup>lmn</sup>"
// ].map(x=>x.split(rep))
// =>
// [
//   abc, <latex>, def, </latex>, ghi, <sub>, jk, </sub>, lmn
//   "", <latex>, def, </latex>, ghi, <sub>, jk, </sub>, lmn
//   "", <latex>, def, </latex>, ghi, <sub>, jk, </sub>, "", <sup>, lmn, </sup>, ""
// ]
// we can have this conclution: the result of split is always:
// content, (seperator, content, )*
// notice that, we assume the tag depth is always 1 or 0 (no nesting)
//
// the func below convert a string to a react component, such as
// <>abc<sub>def</sub></>


// ComponentFromString
export default (s:string): ReactElement => {
  const regex = /(<span class="gs_fscp">|<\/span>|<\/?i>|<\/?b>|<\/?sup>|<\/?sub>|<\/?latex>)/;
  // the <span class="gs_fscp"> is for google scholar, the description of the pub there has this wrapping sometimes
  // e.g. https://scholar.google.ca/citations?view_op=view_citation&hl=en&tzom=420&user=lGFrzvwAAAAJ&cstart=200&pagesize=100&citation_for_view=lGFrzvwAAAAJ:SjuI4pbJlxcC
  const rep_component = /<(span|i|b|sup|sub|latex)[^>]*>/;
  let rslt = s.split(regex);
  let firstContent = rslt[0]
  rslt = rslt.slice(1)

  let components: [string, string][] = []; // component will be like: [ [sup, abc], ...]
  for(let i=0;i<rslt.length;i+=2){
    let component = rslt[i];
    const content = rslt[i+1];
    let match = component.match(rep_component);
    if(match){
      component = match[1];
    }else{
      component = "text";
    }
    
    components.push([component, content]);
  }


  return <>
    {firstContent}
    {components.map((x, ind)=>{
      const [component, content] = x;
      if(component === "i")
        return <i key={ind}>{content}</i>;
      if(component === "b")
        return <b key={ind}>{content}</b>;
      if(component === "sub")
        return <sub key={ind}>{content}</sub>;
      if(component === "sup")
        return <sup key={ind}>{content}</sup>;
      if(component === "span")
        return <span key={ind} style={{fontVariant: "small-caps"}}>{content}</span>;
      if(component === "latex")
        return <InlineMath key={ind} math={content}/>;
      return content; // plain text
    })}
  </>;

}

// e.g.Upper critical fields and two-band superconductivity in Sr<latex>1−x</latex>Eu<latex>x</latex>
// http://localhost/research/expertise-engine/profile/a0c3b206-564f-4e01-b26a-0d32c2bd6bf2